import { GET } from "../../helper/official_website_restfunctions";

export const get_ind_applicant_list = async (applicant_id:any) => {
  const path = `/join_us_page/${applicant_id}`;
  return await GET(path)
    .then((result) => {
      return result;
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};